export default __webpack_public_path__ + "static/media/13.bf9354b3.webp";